import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Login from '@/pages/Login'
import NotFound from '@/pages/NotFound'
import PublicLayout from '@/pages/Layouts/PublicLayout'
import ResetPassword from '@/pages/ResetPassword'  
import RequireAuth from '@/middlewares/RequireAuth'
import MainLayout from './pages/Layouts/MainLayout' 
import Home from './pages/Home' 
import Carrier from './pages/MasterData/Carrier'
import Companies from './pages/MasterData/Companies'
import Operation from './pages/MasterData/Operation'
import Supplier from './pages/MasterData/Supplier'
import Impediment from './pages/MasterData/Impediment'
import ConferenceHub from './pages/ProcessHub/ConferenceHub'
import ParameterConferenceHub from './pages/ProcessHub/ParameterConferenceHub'

const Router = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<PublicLayout />}>
                    <Route path="*" element={<NotFound />} />
                    <Route path="/login" element={<Login />} />
                    <Route
                        path="/recuperar-senha"
                        element={<ResetPassword />}
                    />
                </Route>
                <Route element={<MainLayout />}>
                    <Route
                        path="/" 
                        element={
                            <RequireAuth isAllowed>
                                <Home />
                            </RequireAuth>
                        }
                    > 
                    </Route> 
                    <Route path="masterdata"> 
                        <Route
                            path="carrier"
                            element={ 
                                <RequireAuth isAllowed> 
                                    <Carrier />  
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="companies"
                            element={ 
                                <RequireAuth isAllowed> 
                                    <Companies />  
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="operation"
                            element={ 
                                <RequireAuth isAllowed> 
                                    <Operation />  
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="supplier"
                            element={ 
                                <RequireAuth isAllowed> 
                                    <Supplier />  
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="impediment"
                            element={ 
                                <RequireAuth isAllowed> 
                                    <Impediment />  
                                </RequireAuth>
                            }
                        />
                    </Route>

                     <Route path="processhub"> 
                        <Route
                            path="conferencehub"
                            element={ 
                                <RequireAuth isAllowed> 
                                    <ConferenceHub />  
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="parameter/conferencehub"
                            element={ 
                                <RequireAuth isAllowed> 
                                    <ParameterConferenceHub />  
                                </RequireAuth>
                            }
                        />
                    </Route>
                </Route>
            </Routes>
        </BrowserRouter>
    )
}

export default Router
